import React from 'react';
import { motion } from 'framer-motion';
const specialties = [{
  title: 'Iluminaciones Artesanales',
  desc: 'Babylights, balayage y técnicas de pincel libre para lograr una transición natural y luminosa, pensada para tu tipo de cabello y tono de piel.'
}, {
  title: 'Correcciones de Color',
  desc: 'Neutralizaciones, cambios de base y rescates capilares. Porque un color mal hecho merece una solución experta, no otro error.'
}, {
  title: 'Cortes de Autor',
  desc: 'Cortes con estructura y movimiento, adaptados a tu rostro y tu estilo de vida. Técnica y estética en cada tijera.'
}];
export const Specialties = () => {
  return <section id="specialties" className="bg-[#0A0A0A] py-32 relative" data-id="element-95">
      <div className="max-w-4xl mx-auto px-6" data-id="element-96">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="font-serif text-2xl md:text-3xl text-gold text-center tracking-[0.2em] uppercase mb-24 font-light" data-id="element-97">
          Especialidades
        </motion.h2>

        <div className="flex flex-col gap-16" data-id="element-98">
          {specialties.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex flex-col md:flex-row gap-6 md:gap-12 items-start md:items-center border-b border-gold/20 pb-16 last:border-0" data-id="element-99">
              <h3 className="font-serif text-xl md:text-2xl text-gold uppercase tracking-widest font-light md:w-1/3" data-id="element-100">
                {item.title}
              </h3>
              <p className="font-sans font-light text-offwhite/70 text-sm md:text-base leading-relaxed md:w-2/3" data-id="element-101">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};